import { map, distinctUntilChanged } from "rxjs/operators";
import { Injectable } from "@angular/core";
import { ApiService } from "./api.service";
import { JwtService } from "./jwt.service";
import * as _ from "lodash";
import { Observable } from "rxjs/Rx";
import { BehaviorSubject, ReplaySubject } from "rxjs";
import { User } from "../models/user.model";
import { GlobalState } from "../global.state";
import { Router } from "@angular/router";

@Injectable()
export class UserService {
  private currentUserSubject = new BehaviorSubject<User>(new User());
  public currentUser = this.currentUserSubject
    .asObservable()
    .pipe(distinctUntilChanged());

  private isAuthenticatedSubject = new ReplaySubject<boolean>(1);
  public isAuthenticated = this.isAuthenticatedSubject.asObservable();

  constructor(
    private apiService: ApiService,
    private jwtService: JwtService,
    private _state: GlobalState,
    private router: Router
  ) {}

  populate() {
    // If JWT detected, attempt to get & store user's info
    if (this.jwtService.getToken()) {
      this.apiService.get("user").subscribe(
        (data) => this.setAuth(data.data),
        (err) => this.purgeAuth()
      );
    } else {
      // Remove any potential remnants of previous auth states
      this.purgeAuth();
    }
  }

  setAuth(user: User) {
    // Save JWT sent from server in localstorage
    this.jwtService.saveToken(user.access_token);
    // Set current user data into observable
    this.currentUserSubject.next(user);
    // Set isAuthenticated to true
    this.isAuthenticatedSubject.next(true);
    this.resetInfo();
  }
  logout() {
    this.apiService.get("user/logout").subscribe(() => {
      this.purgeAuth();
    });
  }
  purgeAuth() {
    // Remove JWT from localstorage
    this.jwtService.destroyToken();
    // Set current user to an empty object
    this.currentUserSubject.next(new User());
    // Set auth status to false
    this.isAuthenticatedSubject.next(false);

    this.router.navigate(["/login"]);
  }

  attemptAuth(type, credentials): Observable<User> {
    const route = type === "login" ? "/login" : "";
    return this.apiService.post("user" + route, { user: credentials }).pipe(
      map((data) => {
        this.setAuth(data.data);
        return data.data;
      })
    );
  }
  resetInfo() {
    this.apiService.get("user/roles").subscribe((data) => {
      this._state.notifyDataChanged("[System] UPDATE", data.data);
    });
    this.apiService.get("user/info").subscribe((data) => {
      this._state.notifyDataChanged("[User] UPDATE", data.data);
    });
  }

  passLogin(id: string, username: string) {
    this.apiService.get(`user/passlogin/${id}/${username}`).subscribe(
      (data) => {
        this.setAuth(data.data);
        this.router.navigate(["/"]);
      },
      (err) => {
        this.purgeAuth();
      }
    );
  }
}
